export default "__VITE_ASSET__DIoc5Ywy__"